import { render } from "./NcBadge.vue?vue&type=template&id=5c953a70&scoped=true"
import script from "./NcBadge.vue?vue&type=script&lang=js"
export * from "./NcBadge.vue?vue&type=script&lang=js"

import "./NcBadge.vue?vue&type=style&index=0&id=5c953a70&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5c953a70"]])

export default __exports__